import styled from "styled-components";
import Logo from "../../assets/logo-rodape.svg";

export const Container = styled.div`
  display: flex;
  max-height: 6rem;
  min-height: 6rem;
  background-color: #f3f3f3;
  background-size: 146px;
  background-image: url(${Logo});
  background-repeat: no-repeat;
  background-position: center;
  background-position-x: calc(100% - 2rem);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
`;



// WEBPACK FOOTER //
// ./src/components/Footer/styles.js